import React, { Component } from 'react'
import './style.css'
import Navbar from 'components/Navbar'
import Sidebar from 'components/Sidebar'
import Modal from 'components/Modal'
import Cookie from 'universal-cookie'
import Loading from 'components/Loading'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {isMobile} from 'react-device-detect'
import AdminInMobile from 'views/warning/admin_in_mobile'
import { MuiThemeProvider, createMuiTheme, } from '@material-ui/core/styles'
const themeButton = createMuiTheme({ 
    palette: { 
        secondary: {
            main:'#F44336',
            contrastText: '#FFFFFF',

        },
        primary: {
            main:'#00a1ed',
            contrastText: '#FFFFFF',

        },
    } 
})
const cookie=new Cookie()

export default function Index(props) {
    const token=cookie.get('login_cookie')
    const profile=cookie.get('profile_cookie')
    if(isMobile){
        return <AdminInMobile/>
    }else{
        return (
            <div>
                <Navbar profile={profile}/>
                    <Sidebar token={token} profile={profile}/>
                    <Loading/>
                    <ToastContainer 
                        autoClose={2000}
                        hideProgressBar={true}
                        toastClassName='toast-wrapper'
                        bodyClassName='toast-text'
                        closeButton={false}
                    />
                    <div className='content-wrapper'>
                        <Modal token={token} profile={profile}/>
                        <MuiThemeProvider theme={themeButton}>
                            {props.children}
                        </MuiThemeProvider>
                        
                    </div>
            </div>
        )
    }
    
}

